// extracted by mini-css-extract-plugin
module.exports = {"wrapperLayout":"LayoutModal_wrapperLayout__C1qWt","sWrapper":"LayoutModal_sWrapper__TjuO9","arrow_up":"LayoutModal_arrow_up__FhzAT"};